"use client";

import { Landing } from "modules/landing/LandingPage";

const Page = () => {
  return <Landing />;
};

export default Page;
